<ion-content [fullscreen]="true" class="auth-page">
  <!-- Layout: koomzodesignsystem features/auth/pages/signup (specs/auth.md §5.3). -->
  <app-kz-auth-shell>
    <app-kz-brand-lockup appbar [strapline]="'app.pages.auth.signup.brand.strapline' | translate"></app-kz-brand-lockup>
    <app-kz-language-bar
      appbar
      variant="pill"
      [languages]="languages"
      [activeLang]="(lang$ | async) ?? 'en'"
      [ariaLabel]="'app.pages.auth.signup.aria.language' | translate"
      (langChange)="onLanguageChange($event)"
    ></app-kz-language-bar>

    <app-kz-brand-lockup pitchTop [onPrimary]="true" [strapline]="'app.pages.auth.signup.brand.strapline' | translate"></app-kz-brand-lockup>
    <app-kz-language-bar
      pitchTop
      variant="pill"
      [onPrimary]="true"
      [languages]="languages"
      [activeLang]="(lang$ | async) ?? 'en'"
      [ariaLabel]="'app.pages.auth.signup.aria.language' | translate"
      (langChange)="onLanguageChange($event)"
    ></app-kz-language-bar>

    <div pitchLead>
      <h2 class="pitch__h">{{ 'app.pages.auth.signup.pitch.headline' | translate }}</h2>
      <p class="pitch__p">{{ 'app.pages.auth.signup.pitch.body' | translate }}</p>
    </div>
    <div pitchPills class="pitch__pills">
      <app-auth-pitch-pill icon="phone-portrait-outline">{{ 'app.pages.auth.signup.pitch.pill.phoneFirst' | translate }}</app-auth-pitch-pill>
      <app-auth-pitch-pill icon="cloud-offline-outline">{{ 'app.pages.auth.signup.pitch.pill.offline' | translate }}</app-auth-pitch-pill>
    </div>
    <a pitchFoot class="pitch__tour" routerLink="/walkthrough">
      <ion-icon name="play-circle-outline" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.signup.pitch.tour' | translate }}</span>
    </a>

    <!-- Every field is a dynamic-forms control (kz2 rule). -->
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div>
        <h1 class="form__title">{{ 'app.pages.auth.signup.title' | translate }}</h1>
        <p class="form__lede">{{ 'app.pages.auth.signup.lede' | translate }}</p>
      </div>

      <div class="form__group">
        <div class="form__group-label">{{ 'app.pages.auth.signup.group.login' | translate }}</div>
        <div class="two">
          <kz-dynamic-form-control [model]="modelMap.get('username')" [group]="form"></kz-dynamic-form-control>
          <kz-dynamic-form-control [model]="modelMap.get('password')" [group]="form"></kz-dynamic-form-control>
          <kz-dynamic-form-control [model]="modelMap.get('email')" [group]="form"></kz-dynamic-form-control>
        </div>
      </div>

      <div class="form__group">
        <div class="form__group-label">{{ 'app.pages.auth.signup.group.business' | translate }}</div>
        <kz-dynamic-form-control [model]="modelMap.get('businessName')" [group]="form"></kz-dynamic-form-control>
        <div class="two">
          <kz-dynamic-form-control [model]="modelMap.get('fullName')" [group]="form"></kz-dynamic-form-control>
          <kz-dynamic-form-control [model]="modelMap.get('businessKind')" [group]="form"></kz-dynamic-form-control>
        </div>
        <kz-dynamic-form-control class="headcount" [model]="modelMap.get('headcount')" [group]="form"></kz-dynamic-form-control>
      </div>

      <!-- The terms sentence decides where its two links sit, per language (translateParts). -->
      <div class="terms">
        <kz-dynamic-form-control [model]="modelMap.get('termsAccepted')" [group]="form"></kz-dynamic-form-control>
        <span class="terms__text">
          @for (segment of 'app.pages.auth.signup.terms' | translateParts; track $index) {
            @if (segment.kind === 'text') {
              <span>{{ segment.text }}</span>
            } @else if (segment.name === 'terms') {
              <a class="terms__link" routerLink="/terms-of-service">{{ 'app.pages.auth.signup.terms.termsLink' | translate }}</a>
            } @else if (segment.name === 'privacy') {
              <a class="terms__link" routerLink="/privacy-policy">{{ 'app.pages.auth.signup.terms.privacyLink' | translate }}</a>
            }
          }
        </span>
      </div>

      @if (failure) {
        <app-kz-inline-alert
          role="alert"
          tone="stop"
          icon="alert-circle-outline"
          [heading]="('app.pages.auth.signup.error.' + failure + '.title') | translate"
        >
          {{ ('app.pages.auth.signup.error.' + failure + '.body') | translate }}
          @if (failure === 'appCheck' && websiteUrl) {
            <ion-button class="website" size="small" fill="outline" type="button" (click)="openWebsite()">
              <ion-icon slot="start" name="open-outline" aria-hidden="true"></ion-icon>
              {{ 'app.pages.auth.signup.error.appCheck.action' | translate }}
            </ion-button>
          }
        </app-kz-inline-alert>
      }

      <p class="personal">
        {{ 'app.pages.auth.signup.personal.prompt' | translate }}
        <a routerLink="/signup/personal">{{ 'app.pages.auth.signup.personal.link' | translate }}</a>
      </p>
      <button type="submit" hidden aria-hidden="true" tabindex="-1"></button>
    </form>

    <div reassure class="reassure">
      <app-kz-inline-alert tone="quiet" icon="cloud-offline-outline" [heading]="'app.pages.auth.signup.reassure.offline.title' | translate">
        {{ 'app.pages.auth.signup.reassure.offline.body' | translate }}
      </app-kz-inline-alert>
      <app-kz-inline-alert tone="quiet" icon="construct-outline" [heading]="'app.pages.auth.signup.reassure.forms.title' | translate">
        {{ 'app.pages.auth.signup.reassure.forms.body' | translate }}
      </app-kz-inline-alert>
    </div>

    <button dock class="cta" type="button" (click)="onSubmit()" [disabled]="isLoadingState">
      <span>{{ 'app.pages.auth.signup.cta' | translate }}</span>
      <ion-icon class="cta__icon" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
    </button>
    <div dock class="docklinks">
      <a class="docklinks__tour" routerLink="/walkthrough">
        <ion-icon name="play-circle-outline" aria-hidden="true"></ion-icon>
        <span>{{ 'app.pages.auth.signup.dock.tour' | translate }}</span>
      </a>
      <span class="docklinks__account">
        {{ 'app.pages.auth.signup.haveAccount' | translate }}
        <a routerLink="/login">{{ 'app.pages.auth.signup.login' | translate }}</a>
      </span>
    </div>
  </app-kz-auth-shell>
</ion-content>
